import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";
import HeaderBread from "../../../components/HeaderBread";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import {
  getNotificationById,
  getSailingData,
} from "../../../utils/ApiCalls/Mobile/Notification";

import CreateMobileNotificationInput from "../../../components/MobileNotification/CreateMobileNotification";

const EditActivityMaster = () => {
  const params = useParams();
  const [notificationData, setNotificationData] = useState({});
  const [vesselData, setVesselData] = useState({});
  const [sailingData, setsailingData] = useState([]);
  const [, dispatch] = useDataLayerValue();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Notifications",
      route: `/shore/notifications/${params?.vessel}`,
    },
    {
      title: "Edit Notification",
      route: `/shore/notifications/${params?.vessel}/edit/${params?.id}`,
    },
  ];
  useEffect(() => {
    getData(params?.id);
  }, [params]);

  const getData = async (value) => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let data = await getNotificationById(value);
    const sailingDataFetched = await getSailingData();

    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });

    setNotificationData(data.data);
    setsailingData(sailingDataFetched.data);
    setVesselData(data?.vesselData);
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };

  return (
    <Layout type={"update_per"} module_data={"Notifications"}>
      <CustomHeaderTitle title={"Edit Notification"} />
      <HeaderBread
        navigation={navigation}
        title={"Edit Categories"}
      ></HeaderBread>
      {notificationData && (
        <CreateMobileNotificationInput
          notificationData={notificationData}
          sailingData={sailingData}
          vesselData={vesselData}
          readOnly={!notificationData?.isScheduled}
        />
      )}
    </Layout>
  );
};

export default EditActivityMaster;
